var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11526_18776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C7.6119 18 6.47917 17.7767 5.60179 17.33C4.7244 16.8833 4.28571 16.3067 4.28571 15.6C4.28571 15.28 4.38065 14.9833 4.57054 14.71C4.76042 14.4367 5.0256 14.2 5.36607 14L6.60357 15.18C6.48571 15.2333 6.35804 15.2933 6.22054 15.36C6.08304 15.4267 5.975 15.5067 5.89643 15.6C6.06667 15.8133 6.45952 16 7.075 16.16C7.69048 16.32 8.33214 16.4 9 16.4C9.66786 16.4 10.3128 16.32 10.9348 16.16C11.5568 16 11.953 15.8133 12.1232 15.6C12.0315 15.4933 11.9137 15.4067 11.7696 15.34C11.6256 15.2733 11.4881 15.2133 11.3571 15.16L12.575 13.96C12.9417 14.1733 13.2232 14.4167 13.4196 14.69C13.6161 14.9633 13.7143 15.2667 13.7143 15.6C13.7143 16.3067 13.2756 16.8833 12.3982 17.33C11.5208 17.7767 10.3881 18 9 18Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01964 13.6C10.3161 12.6267 11.2917 11.65 11.9464 10.67C12.4285 9.94847 12.7331 9.22514 12.8603 8.5H14.4418C14.2926 9.50321 13.857 10.5232 13.1348 11.56C12.2247 12.8667 10.8464 14.2133 9 15.6C7.15357 14.2133 5.7753 12.8667 4.86518 11.56C3.95506 10.2533 3.5 8.97333 3.5 7.72C3.5 6.77333 3.66696 5.94333 4.00089 5.23C4.33482 4.51667 4.76369 3.92 5.2875 3.44C5.81131 2.96 6.4006 2.6 7.05536 2.36C7.71012 2.12 8.35833 2 9 2C9.64167 2 10.2899 2.12 10.9446 2.36C11.1353 2.42989 11.3204 2.50996 11.5 2.6002V4.5203C10.6956 3.90677 9.8623 3.6 9 3.6C8.08333 3.6 7.1994 3.94667 6.34821 4.64C5.49702 5.33333 5.07143 6.36 5.07143 7.72C5.07143 8.61333 5.39226 9.54333 6.03393 10.51C6.6756 11.4767 7.67083 12.5067 9.01964 13.6Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.2C9.43214 9.2 9.80208 9.04333 10.1098 8.73C10.4176 8.41667 10.5714 8.04 10.5714 7.6C10.5714 7.16 10.4176 6.78333 10.1098 6.47C9.80208 6.15667 9.43214 6 9 6C8.56786 6 8.19792 6.15667 7.89018 6.47C7.58244 6.78333 7.42857 7.16 7.42857 7.6C7.42857 8.04 7.58244 8.41667 7.89018 8.73C8.19792 9.04333 8.56786 9.2 9 9.2Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.5V5.83333H12.5V4.16667H14.1667V2.5H15.8333V4.16667H17.5V5.83333H15.8333V7.5H14.1667Z",
    fill: "#374E92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11526_18776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconMap);
export default __webpack_public_path__ + "static/media/list_icon_map.6644e591c8273acbde4618598121f430.svg";
export { ForwardRef as ReactComponent };